module.exports = ".caducidades-nav {\n  position: relative; }\n  .caducidades-nav .expirations-number {\n    height: 20px;\n    position: absolute;\n    top: 5px;\n    right: -10px;\n    z-index: 9;\n    font-size: 10px;\n    line-height: 20px;\n    text-align: center;\n    width: 20px;\n    background: #e94539;\n    border-radius: 100%;\n    font-weight: 600; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/app-menu/app-menu.component.scss
// module id = ./src/app/common/app-menu/app-menu.component.scss
// module chunks = main